export const DEFAULT_POLLING_INTERVAL = 10000;
export const DEFAULT_STOP_POLLING_TIMEOUT = 120000;
export const DEFAULT_MAX_ATTEMPTS = Math.floor(DEFAULT_STOP_POLLING_TIMEOUT / DEFAULT_POLLING_INTERVAL);
